import store from '../store'

export default (router) => {
  // register each pageview
  router.afterEach((to, from) =>
    store.dispatch('PAGEVIEW', { to, from }))
}



// WEBPACK FOOTER //
// ./src/router/afterEach.js